export default __webpack_public_path__ + "static/media/Verify_Header.d8824f8d.svg";